function onInput(el, ele, binding, vnode) {
  function handle() {
    let val = ele.value
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
      // 清除"数字"和"."以外的字符
      val = val.replace(/[^\d.]/g, '')
      // 只保留第一个, 清除多余的.
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      // 第一个字符如果是.号，则补充前缀0
      val = val.replace(/^\./g, '0.')
      if (binding.value) {
        // 整数和小数长度同时限制
        if (binding.value.integer && binding.value.decimal) {
          let integer = binding.value.integer
          let decimal = binding.value.decimal
          let array = val.split('.')
          if (array.length > 1) {
            val = array[0].substr(0, integer) + '.' + array[1].substr(0, decimal)
          } else {
            val = array[0].substr(0, integer)
          }
        }
        // 纯小数长度限制
        if (!binding.value.integer && binding.value.decimal) {
          let decimal = binding.value.decimal
          let array = val.split('.')
          if (array.length > 1) {
            val = 0 + '.' + array[1].substr(0, decimal)
          } else {
            if (array[0] != 0) {
              val = ''
            }
          }
        }
      }
    } else {
      val = ele.value.replace(/[^\d]/g, '')
    }
    ele.value = val

    if (binding.value && binding.value.set) {
      // 手动刷新data中绑定的属性
      let names = binding.value.name.split('.')
      if (names.length == 0) {
        binding.value.set[binding.value.name] = ele.value;
      }
      if (names.length == 2) {
        binding.value.set[names[0]][names[1]] = ele.value;
      }
      if (names.length == 4) {
        binding.value.set[names[0]][names[1]][names[2]][names[3]] = ele.value;
      }
    }
  }

  return handle
}

const numberInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  }
}

export default numberInput




// WEBPACK FOOTER //
// ./src/assets/js/custom-instruction.js